import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9db844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "text" }




export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTab',
  props: {
  selected: {
    type: Boolean,
    default: false,
  },
  fade: {
    Boolean,
    default: false,
  },
  text: {
    type: String,
    default: () => "",
  },
  linkTo: {
    type: String,
    default: () => "/",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.linkTo,
    class: _normalizeClass(['tab', __props.selected ? 'selected' : '', __props.fade ? 'faded' : '']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked', __props.text))),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hover', __props.text))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hover', null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})